// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r6-c";
export var backButton = "_r6-4";
export var backIcon = "_r6-5";
export var chevronShortcut = "_r6-6";
export var container = "_r6-1";
export var editor = "_r6-8";
export var editorWrapper = "_r6-7";
export var prefix = "_r6-2";
export var searchIcon = "_r6-3";
export var suffix = "_r6-9";
export var suffixContent = "_r6-a";
export var suffixText = "_r6-b";
export var wrapper = "_r6-0";